export function unwrapAdminListItems<T>(payload: unknown, preferredKeys: string[]): T[] {
    if (Array.isArray(payload)) {
        return payload as T[];
    }

    if (!payload || typeof payload !== 'object') {
        return [];
    }

    const record = payload as Record<string, unknown>;

    for (const key of preferredKeys) {
        const value = record[key];
        if (Array.isArray(value)) {
            return value as T[];
        }
    }

    for (const [key, value] of Object.entries(record)) {
        if (key !== 'total_count' && Array.isArray(value)) {
            return value as T[];
        }
    }

    return [];
}
